// @flow

import i18n from "i18next";
import React from "react";
import { useSelector } from "react-redux";

import { getUserStatus } from "src/reducers";
import { StatusContainer } from "./styles";
import { userStatusTranslated } from "src/constants/users";

import type { UID, UserStatus } from "src/types";

type Props = {
  uid: UID
};

const Status = ({ uid }: Props) => {
  const status: UserStatus = useSelector(({ app }) => getUserStatus(app, uid));
  const translatedStatus = i18n.t(userStatusTranslated[status]);
  return <StatusContainer>{translatedStatus}</StatusContainer>;
};

export default Status;
